import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        lawyerType: String,
    };

    static targets = [
        'billingInformationContainer',
        'lawFirmContainer',
        'individualLawyerContainer',
        'lawyerType',
        'billingAddressDifferentFromLawFirmAddress',
        'billingAddress',
        'swornDateYear',
        'registrationNumber',
        'lawFirm',
    ];


    initialize() {
        if (this.lawyerTypeValue) {
            this.lawyerTypeChanged({ target: { value: this.lawyerTypeValue } });

            $(this.billingAddressTarget).parent().find('.invalid-feedback').hide().removeClass('d-block');
        }

        this.lawyerTypeTarget.addEventListener('change', this.lawyerTypeChanged.bind(this));

        this.billingAddressDifferentFromLawFirmAddressTarget.addEventListener('change', this.billingAddressDifferentFromLawFirmAddressChanged.bind(this));

        this.billingAddressDifferentFromLawFirmAddressChanged({ target: { checked: this.billingAddressDifferentFromLawFirmAddressTarget.checked } });
    }

    lawyerTypeChanged(event) {
        $(this.lawyerTypeTarget).parent().find('.invalid-feedback').hide().removeClass('d-block');

        $(this.billingInformationContainerTarget).show();
        $(this.billingAddressDifferentFromLawFirmAddressTarget).show();

        if ('law_firm' === event.target.value) {
            $(this.lawFirmContainerTarget).show();
            $(this.individualLawyerContainerTarget).hide();

            $(this.swornDateYearTarget).parent().find('.invalid-feedback').hide().removeClass('d-block');

            if (this.hasRegistrationNumberTarget) {
                $(this.registrationNumberTarget).parent().find('.invalid-feedback').hide().removeClass('d-block');
            }
        } else {
            $(this.lawFirmContainerTarget).hide();
            $(this.individualLawyerContainerTarget).show();

            $(this.lawFirmTarget).parent().find('.invalid-feedback').hide().removeClass('d-block');
        }
    }

    billingAddressDifferentFromLawFirmAddressChanged(event) {
        if (event.target.checked) {
            $(this.billingAddressTarget).show();
        } else {
            $(this.billingAddressTarget).hide();
        }
    }
}
